// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M4 6L8 2L12 6',
  'M8 2V7.5C8 8.56 7.58 9.58 6.83 10.33L3 14.16',
  'M13 14.16L9.75 10.91',
];
